import React from 'react';
import { useNavigate } from 'react-router-dom';
const WireframeBookingPage = () => {
  const navigate = useNavigate();
  return <div className="w-full bg-white p-3 font-mono text-[11px]" data-id="element-207">
      {/* Wireframe Header */}
      <header className="border border-dashed border-gray-400 p-2 mb-4" data-id="element-208">
        <div className="flex justify-between items-center" data-id="element-209">
          <div className="bg-gray-300 h-6 w-20 flex items-center justify-center text-[10px] text-gray-600" data-id="element-210">
            LOGO
          </div>
          <div className="flex gap-2" data-id="element-211">
            <div className="bg-gray-200 h-5 w-12 flex items-center justify-center text-[10px] text-gray-500" data-id="element-212">
              Nav
            </div>
            <div className="bg-gray-200 h-5 w-12 flex items-center justify-center text-[10px] text-gray-500" data-id="element-213">
              Nav
            </div>
            <div className="bg-gray-200 h-5 w-12 flex items-center justify-center text-[10px] text-gray-500" data-id="element-214">
              Nav
            </div>
          </div>
        </div>
      </header>

      <div className="max-w-3xl mx-auto" data-id="element-215">
        <div className="bg-gray-200 h-4 w-20 mb-2 flex items-center px-1 text-[9px] text-gray-500" data-id="element-216">
          ← Back
        </div>
        <div className="bg-gray-300 h-7 w-44 mb-4 flex items-center px-2 text-[11px] text-gray-600" data-id="element-217">
          H1: Book Appointment
        </div>

        {/* Selected Service */}
        <div className="border border-dashed border-gray-400 bg-gray-100 p-3 mb-4" data-id="element-218">
          <div className="bg-gray-300 h-5 w-28 mb-1 flex items-center px-2 text-[10px] text-gray-600" data-id="element-219">
            Selected Service
          </div>
          <div className="bg-gray-200 h-3.5 w-24 flex items-center px-2 text-[9px] text-gray-500" data-id="element-220">
            Duration • Price
          </div>
        </div>

        {/* Date Selection */}
        <div className="border border-dashed border-gray-400 p-3 mb-4" data-id="element-221">
          <div className="bg-gray-300 h-5 w-24 mb-3 flex items-center px-2 text-[10px] text-gray-600" data-id="element-222">
            📅 Select Date
          </div>
          <div className="flex gap-1.5 overflow-x-auto" data-id="element-223">
            {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, i) => <div key={day} className={`border ${i === 0 ? 'border-gray-600 bg-gray-400 text-white' : 'border-gray-400'} p-1.5 min-w-[42px] text-center`} data-id="element-224">
                <div className="text-[8px]" data-id="element-225">{day}</div>
                <div className="text-sm font-bold leading-tight" data-id="element-226">{15 + i}</div>
                <div className="text-[8px]" data-id="element-227">Jun</div>
              </div>)}
          </div>
        </div>

        {/* Therapist Selection */}
        <div className="border border-dashed border-gray-400 p-3 mb-4" data-id="element-228">
          <div className="bg-gray-300 h-5 w-28 mb-3 flex items-center px-2 text-[10px] text-gray-600" data-id="element-229">
            Select Therapist
          </div>
          <div className="grid grid-cols-2 gap-2" data-id="element-230">
            {[1, 2, 3].map(item => <div key={item} className={`border ${item === 1 ? 'border-gray-600' : 'border-gray-400'} p-2`} data-id="element-231">
                <div className="flex gap-2" data-id="element-232">
                  <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center text-[9px]" data-id="element-233">
                    👤
                  </div>
                  <div className="space-y-0.5" data-id="element-234">
                    <div className="bg-gray-300 h-4 w-20 flex items-center px-1 text-[9px] text-gray-600" data-id="element-235">
                      Name
                    </div>
                    <div className="bg-gray-200 h-3 w-16 flex items-center px-1 text-[8px] text-gray-500" data-id="element-236">
                      ⭐ X.X
                    </div>
                    <div className="flex gap-0.5" data-id="element-237">
                      <div className="bg-gray-200 h-3.5 px-1 flex items-center text-[8px] text-gray-500" data-id="element-238">
                        Tag
                      </div>
                      <div className="bg-gray-200 h-3.5 px-1 flex items-center text-[8px] text-gray-500" data-id="element-239">
                        Tag
                      </div>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        {/* Time Selection */}
        <div className="border border-dashed border-gray-400 p-3 mb-4" data-id="element-240">
          <div className="bg-gray-300 h-5 w-24 mb-3 flex items-center px-2 text-[10px] text-gray-600" data-id="element-241">
            🕐 Select Time
          </div>
          <div className="grid grid-cols-5 md:grid-cols-6 gap-1.5" data-id="element-242">
            {['9:00', '10:00', '11:00', '12:00', '1:00', '2:00', '3:00', '4:00', '5:00'].map((time, i) => <div key={time} className={`border ${i === 2 ? 'border-gray-600 bg-gray-400 text-white' : 'border-gray-400'} p-1 text-center text-[10px]`} data-id="element-243">
                {time}
              </div>)}
          </div>
        </div>

        {/* Continue */}
        <div className="flex justify-end" data-id="element-244">
          <div className="bg-gray-400 h-8 w-32 flex items-center justify-center text-[10px] text-white" data-id="element-245">
            Continue →
          </div>
        </div>
      </div>

      {/* Annotation */}
      <div className="text-[9px] text-gray-400 text-center mt-4 mb-3" data-id="element-246">
        Wireframe v1.0 — Booking Flow
      </div>

      {/* Navigation */}
      <div className="flex justify-center gap-2" data-id="element-247">
        <button onClick={() => navigate('/wireframe/services')} className="border border-gray-400 px-3 py-1.5 text-[10px] text-gray-600 hover:bg-gray-100" data-id="element-248">
          ← Services
        </button>
        <button onClick={() => navigate('/wireframe/checkout')} className="border border-gray-400 px-3 py-1.5 text-[10px] text-gray-600 hover:bg-gray-100" data-id="element-249">
          → Checkout
        </button>
      </div>
    </div>;
};
export default WireframeBookingPage;